/*中英文字符换算*/
String.prototype.getStrBytesLen = function() {
    var bytesCount = 0;
    var value = "";
    var len = this.length;
    for (var i = 0; i < len; i++) {
        var c = this.charAt(i);
        value += c;
        if (/^[\u0000-\u00ff]$/.test(c)) {
            bytesCount += 1;
        } else {
            bytesCount += 2;
        }
    }
    return bytesCount;
};